export const clamp = (value: number, min: number, max: number): number => Math.min(Math.max(value, min), max)

// based on https://chatgpt.com/share/67e13e12-7d0c-8002-b79f-f414f10208d6
export const evenlyItems = <T>(arr: T[], y: number): T[] => y === 1 ?
    middleItem(arr) : y > arr.length ? arr : Array.from({ length: y }, (_, i) => arr[Math.round(i * (arr.length - 1) / (y - 1))]);

// export const middleItem = <T>(arr: T[]): T[] => [arr[Math.floor(arr.length / 2)]]
export const middleItem = <T>(arr: T[]): T[] => [arr[1]]